import React from 'react';
import classNames from 'classnames';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { Tag, Button } from 'antd';
import { resourceRequestNumberTemplate } from '../../utility';

const statusMap = {
  '0': 'open',
  '1': 'accepted',
  '2': 'declined',
  '3': 'approved'
}

const requestTypeMap = {
  '0': 'Loan',
  '1': 'Investment'
}

dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);

const ResourceRequestListItemAlt = ({
  id,
  requestType,
  number,
  createdOn,
  status,
  lastModifiedOn,
  initiatedBy,
  initiatedFor,
  onDoubleClick,
  onDelete,
  processedBy,
}) => {
  let rootClasses = classNames(
    'rrq-list_item', {
      [`rrq-list_item--${statusMap[status]}`]: true
    }
  );

  return (
    <li className={rootClasses} data-item-id={id} onDoubleClick={onDoubleClick}>
      <div className="rrq-list_item_number-col">
        <h3>{resourceRequestNumberTemplate(id)} <span>{requestTypeMap[requestType]}</span></h3>
        <div className="rrq-list_item_secondary-text">{`on ${dayjs(createdOn).format('MMMM Do YYYY')} (${dayjs(createdOn).fromNow()})`}</div>
        <div className="rrq-list_item_secondary-text">{`by ${initiatedBy.fullName}`}</div>
      </div>
      <div className="rrq-list_item_col">
        <h4>Initiated for</h4>
        <div className="rrq-list_item_primary-text">{initiatedFor.organizationName}</div>
        <div className="rrq-list_item_primary-text">{initiatedFor.fullName}</div>
      </div>
      <div className="rrq-list_item_col">
        <h4>Requested Number</h4>
        <div className="rrq-list_item_primary-text">{number}</div>
      </div>
      <div className="rrq-list_item_col">
        <h4>Status</h4>
        <Tag className={`rrq-list_item_tag--${statusMap[status]}`}>{statusMap[status]}</Tag>
      </div>
      <div className="rrq-list_item_col">
        <div className="rrq-list_item_primary-text">{`Last Updated ${dayjs(lastModifiedOn).fromNow()}`}</div>
        <div className="rrq-list_item_secondary-text">{`on ${dayjs(lastModifiedOn).format('lll')} `}</div>
        <div className="rrq-list_item_secondary-text">{`by ${processedBy ? processedBy.fullName : initiatedBy.fullName} `}</div>
      </div>
      <div className="controls">
        <Button type="danger" onClick={() => onDelete(id)}>Delete</Button>
      </div>
    </li>
  )
}

export default ResourceRequestListItemAlt;
